import { createSlice } from "@reduxjs/toolkit";

export const initialSmsTemplateLocalState = {
  smsTemplate: {
    template_name: "",
    category: "",
    // salutation: "",
    // disclaimer: "",
    body: "",
    // links: null,
    // signature: "",
    lead_stage: "",
    placeholders: [],
  },
};

export const sendSmsLocalState = {
  smsSend: {
    templateId: "",
    to: "",
    message: "",
    send_to_all: false,
  },
};

export const smsTemplateSlice = createSlice({
  name: "smsTemplate",
  initialState: {
    newSmsTemplateLocal: initialSmsTemplateLocalState,
    newSmsSendLocal: sendSmsLocalState,
    smsTemplates: [],
    isSendSmsTemplateResponse: false,
    isSmsTemplateResponse: false,
    isSmsTemplateUpdateSuccess: false,
    isSmsTemplateUpdateError: false,
    isDeleteSmsTemplateSuccess: false,
  },
  reducers: {
    setNewSmsTemplateLocal: (state, action) => {
      state.newSmsTemplateLocal = {
        ...state.newSmsTemplateLocal,
        ...action.payload,
      };
    },

    resetNewSmsTemplateLocal: (state) => {
      state.newSmsTemplateLocal = initialSmsTemplateLocalState;
    },

    getSmsTemplateAction: (state) => {},
    setSmsTemplateAction: (state, { payload }) => {
      console.log("payload", payload);
      state.smsTemplates = payload;
    },

    addSmsTemplateAction: (state, { payload }) => {},
    setAddSmsTemplateResponse: (state, { payload }) => {
      state.isSmsTemplateResponse = payload;
    },

    updateSmsTemplateAction: (state, { payload }) => {},
    setUpdateSmsTemplateAction: (state, { payload }) => {
      state.isSmsTemplateUpdateSuccess = payload;
    },
    deleteSmsTemplateAction: (state, { payload }) => {},
    setDeleteSmsTemplateSuccessAction: (state, { payload }) => {
      state.isDeleteSmsTemplateSuccess = payload;
    },

    sendSmsTemplateAction: (state, { payload }) => {},
     sendSmsTemplateResponseAction: (state, { payload }) => {
      state.isSendSmsTemplateResponse = payload;
    },

    setNewSmsSendLocal: (state, action) => {
      state.newSmsSendLocal = {
        ...state.newSmsSendLocal,
        ...action.payload,
      };
    },
    resetNewSmsSendLocal: (state) => {
      state.newSmsSendLocal = sendSmsLocalState;
    },
  },
});

const {
  setNewSmsTemplateLocal,
  resetNewSmsTemplateLocal,
  getSmsTemplateAction,
  setSmsTemplateAction,
  addSmsTemplateAction,
  setAddSmsTemplateResponse,
  updateSmsTemplateAction,
  setUpdateSmsTemplateAction,
  deleteSmsTemplateAction,
  setDeleteSmsTemplateSuccessAction,
  sendSmsTemplateAction,
  sendSmsTemplateResponseAction,
  setNewSmsSendLocal,
  resetNewSmsSendLocal,
} = smsTemplateSlice.actions;

export {
  setNewSmsTemplateLocal,
  resetNewSmsTemplateLocal,
  getSmsTemplateAction,
  setSmsTemplateAction,
  addSmsTemplateAction,
  setAddSmsTemplateResponse,
  updateSmsTemplateAction,
  setUpdateSmsTemplateAction,
  deleteSmsTemplateAction,
  setDeleteSmsTemplateSuccessAction,
  sendSmsTemplateAction,
  sendSmsTemplateResponseAction,
  setNewSmsSendLocal,
  resetNewSmsSendLocal,
};

export default smsTemplateSlice.reducer;
